import React, { useState } from 'react'
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";



const About = () => {

    const [counterstart, setCounterStart] = useState(false);
    const { ref } = useInView({
        threshold: 0.2,
        triggerOnce: true,
        onChange: (inView) => setCounterStart(inView)
    });

    return (
        <>
            <div id='Topmargin1' >
                <div className='about_banner'>
                    <img src='About us (4).png' className='about_image' alt=''></img>
                </div>
            </div>

            <div className='container doctor_content'>
                <div className='row'>
                    <div className='col-md-6 col-sm-12'>
                        <img src='Banner.jpg' alt=''></img>
                    </div>
                    <div className='col-md-6 col-sm-12 doctor_content_text mb-2'>
                        <p>Welcome to Pinnamaneni Hospital</p>
                        <h2>Your Trusted Partner in Healthcare</h2>
                        <p>Effective treatment begins with the right diagnostics. Pinnamaneni Hospital is fully equipped with advanced technologies and medical devices. Making a dream come true takes effort in the right timing and with the right doctors. Pinnamaneni doesn't compromise in making those efforts until we see fruitful results using modern diagnostics.</p>
                        <div class="features-grid">
                            <div class="feature-box">
                                <div class="icon"><img src="png-transparent-computer-icons-medical-bag-medicine-physician-medical-icons-rectangle-logo-grass-thumbnail.png" alt="Health Care" /></div>
                                <div class="text">
                                    <h3>HEALTH CARE</h3>
                                    <p>Caring Beyond Limits,<br />Healing with Heart</p>
                                </div>
                            </div>

                            <div class="feature-box">
                                <div class="icon"><img src="images.png" alt="Emergency Unit" /></div>
                                <div class="text">
                                    <h3>EMERGENCY UNIT</h3>
                                    <p>Swift Care, Compassionate<br />Response</p>
                                </div>
                            </div>

                            <div class="feature-box">
                                <div class="icon"><img src="download.png" alt="Lab Test Reports" /></div>
                                <div class="text">
                                    <h3>LAB TEST REPORTS</h3>
                                    <p>Precision in Diagnostics,<br />Results with Trust</p>
                                </div>
                            </div>

                            <div class="feature-box">
                                <div class="icon"><img src="pngtree-flatstyle-heartbeat-line-with-heart-icon-on-white-background-vector-png-image_41126950.jpg" alt="Qualified Doctors" /></div>
                                <div class="text">
                                    <h3>QUALIFIED DOCTORS</h3>
                                    <p>Expertise Beyond Measure,<br />Your Health in Trusted</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='container doctor_content_text'>
                <h2 className='mb-2 text-center'>Let’s Know Short Story About Pinnamaneni Hospital</h2>
                <p>July 15th, 1976 marked the beginning of Rangarao Memorial Pinnamaneni Nursing Home. The legacy began with Dr. Kanakamedala Rangarao, who began his practice in 1946, with Rangarao Hospital. He was the first medical practitioner in all of Vuyyuru. He graduated from Andhra Medical College, Visakhapatnam.</p>
                <p>He presided as the president of the Panchayat for 3 terms. He was a senate member of Andhra Medical College. He was the first chairman of the Cane Development Council. Finally, he was the MLA of Vuyyuru for 2.5 years.</p>
                <p>His generosity knew no bounds, serving the poor and needy, he did not charge for his services. This changed many lives, as he treated 40 villages in the Vuyyuru region.</p>
                <p>He had 2 daughters and 1 son. One of whom was Kasturi Pinnamaneni. Kasturi worked at Christian Bethel Hospital (CBM), as a medical officer for 4.5 years serving Vuyyuru where she delivered several famous people.</p>
                 <p>She married Dr. Chandramohan Pinnamaneni on March 25th, 1976. Dr. Chandramohan was the secretary of IMA for 13 years. He did public service at Rotary Hospital, and went to the US in 1995 and raised money for the hospital, and old age home. As a chairman and secretary, conducted several medical camps for the public to serve people in need.</p>
                <p>Going back to 1976, Working together, Kasturi and Chandramohan founded Rangarao Memorial Pinnamaneni Nursing Home. They began their practice in a rental building until they later shifted to Katuru Road in 1984. They dealt with all types of cases in a 24hr service. They had 2 children, one of whom was Dr. Pawan Kalyan Pinnamaneni, who is now the secretary of IAP.</p>
                <p>As Dr. Kasturi and Chandramohan winded down their clinical practice, Dr. Kalyan continued the legacy. Dr. Pawankalyan completed his undergraduate from ASRAM ( Alluri Sitaramaraju Academy of Medical Sciences, Eluru). He completed post graduate training in pediatrics from prestigious Bharati Vidya peeth, Pune. He then completed fellowship in Pediatric Pulmonology, Allergy and Sleep Medicine in Australia and returned in 2020.</p>
                <h2 className='mt-2 mb-2 text-center'>About Pinnamaneni Hospital</h2>
                <p>“Pinnamaneni Mother and Child Hospital is the best Maternity hospital in Vyuru, Andhra Pradesh with highly experienced Gynecologist, Obstetrician, and pediatricians. Our Hospital provides complete care for women and children, we focus on pregnancy care, natural childbirth, normal delivery & painless delivery. Pinnamaneni Mother and Child Hospital offers patients the highest quality care and most advanced treatment in the field of Obstetric gynecologist & pediatrics.</p>
                <h2 className='mt-2 mb-2 text-center'>Why Choose Us</h2>
                <p className='text-center'><b >We’re Setting the New</b></p>
                <p className='text-center'><b>Standards in Medical Sector</b></p>
                <p><b>Modern Technology</b></p>
                <p>Technology advancements are a boon to the industry so as to our hospital as we use advanced equipment for treatments.</p>
                <p><b>Certified Doctors</b></p>
                <p>Our doctors are hospital's pride, they strengthen our organization.</p>
                <p><b>Success Of Treatment</b></p>
                <p>It's been 46 yrs in the service. The stand we got and the belief that our patients have can show the standard of our treatments.</p>

            </div>

            <div className="container mt-5">
                <div className="row">
                    {[
                        { end: 10, label: "+Years of Experienced" },
                        { end: 75, label: "+Number of Beds" },
                        { end: 20, label: "+Number of Doctors" },
                        { end: 100, label: "+Number of Staff" },
                    ].map((item, idx) => (
                        <div className="col-md-3" key={idx} ref={ref}>
                            <div className="Counter">
                                <h1 className="value text-center" style={{color:'#722e85'}}>
                                    {counterstart && <CountUp start={0} end={item.end} duration={2} />}
                                </h1>
                                <h5 className='text-center'>{item.label}</h5>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    )
}

export default About